import React from 'react';
import { ReCaptchaCallback } from '@forgerock/javascript-sdk';
import HCaptcha from '@hcaptcha/react-hcaptcha';

interface Props {
  callback: ReCaptchaCallback;
}

export const Captcha = ({ callback }: Props) => {
  const handleVerification = (token: string) => {
    callback.setResult(token);
  };

  return (
    <div className="flex justify-center">
      <HCaptcha sitekey={callback.getSiteKey()} onVerify={(token) => handleVerification(token)} />
    </div>
  );
};
